import React, { Component} from "react";
import { CallAPI, GetTzAwareTime, GetCookieFunction, PrepTextForDisplay, BirthdayToAge } from '../../utils/util';
import { PatientNav } from './patientnav';
import { useLocation, useNavigate, useParams } from "react-router-dom";
import Button from "react-bootstrap/Button";
import EditIcon from "../../resources/images/icon_edit.png";
import HistoryIcon from "../../resources/images/icon_history.png";

function withRouter(Component) {
    function ComponentWithRouterProp(props) {
        let location = useLocation();
        let navigate = useNavigate();
        let params = useParams();

        return (
            <Component
                {...props}
                router={{ location, navigate, params }}
            />
        );
    }
    return ComponentWithRouterProp;
}

class PatientProfile extends Component {
    constructor(props) {
        super(props);
        this.state = {
            "patientId": this.props.router.params.patientId,
            "userType": GetCookieFunction("User").type,
            "pFound": true,
            "p_Allergies": [],
            "p_Meds": [],
            "p_Surgeries": [],
            "p_DOrder": {},
            "p_PastMedical": [],
            "p_ReviewSystems": []
        };
    }

    componentDidMount() {
        CallAPI({}, `patients/${this.state.patientId}/basic`, 'GET', (res) => {
            this.setState({
                "pFName":res.fName, 
                "pLName":res.lName, 
                "bDay":res.bDay, 
                "gender":res.gender, 
                "address":res.address, 
                "phone":res.pNum, 
                "nextKinName":res.nextKinName,
                "nextKinNum":res.nextKinNum,
                "patientCode":res.patientCode
            });

            // Fetch full profile for email and city/district
            CallAPI({}, `patients/${this.state.patientId}/complete`, 'GET', (res) => {
                this.setState({
                    "p_Email": res.email || "",
                    "p_City": res.city || "",
                    "p_District": res.district || "",
                    "p_Active": res.active,
                    "p_CenterName": res.centerName || "—"
                });
            });

            // If patient found, lookup more information
            CallAPI({}, `patients/${this.state.patientId}/patientInfo`, 'GET', (res) => { 
                this.setState({
                    "p_RefDocName": (res.Referral_FName ?? "None") + " " + (res.Referral_LName ?? ""),
                    "p_RefDocPhone": res.Referral_Phone ? res.Referral_Phone : "--",
                    "p_BloodGroup": res.BGroup,
                    "p_Transplant": res.TransplantYear ? res.TransplantYear : "No transplants",
                    "p_Hepatitis": res.Hepatitis ? "Yes" : "No",
                    "p_Income": res.Income,
                    "p_Employed": res.AbleToWork ? "Yes" : "No",
                    "p_Zakah": res.ZakatEligible ? "Yes" : "No",
                    "p_RegDate": res.RegistrationDate,
                    "p_CurIllnessHist": (res.HistoryOfIllness ? PrepTextForDisplay(res.HistoryOfIllness) : "NONE"),
                    "p_RiskBondSigned": res.Risk_Bond_Signed ? "Yes" : "No"
                });
            });

            // Get patient's checkin status
            // Get past medical history
            CallAPI(this.state, `patients/${this.state.patientId}/checkinStatus`, `GET`, (res) => {
                this.setState({
                    "p_checkedIn": res.checkedIn,
                    "p_dialysisStarted": res.dialysisStarted
                })
            })

            // Get past medical history
            CallAPI(this.state, `patients/${this.state.patientId}/15/record`, `GET`, (res) => {
                this.setState({
                    "p_PastMedical": res.items ?? "NONE"
                })
            })

            // Get the medical history information
            CallAPI({}, `patients/${this.state.patientId}/medicalHistory`, 'GET', (res) => { 
                this.setState({
                    "p_SocialHist": (res.SocialHistory ? PrepTextForDisplay(res.SocialHistory) : "NONE"),
                    "p_FamilyHist": (res.FamilyHistory ? PrepTextForDisplay(res.FamilyHistory) : "NONE")
                });
            });

            // Get review of systems
            for(var i = 1; i <= 14; i++) {
                CallAPI(this.state, `patients/${this.state.patientId}/${i}/record`, `GET`, (res) => {
                    this.setState(prev => {
                        let historyCopy = JSON.parse(JSON.stringify(prev.p_ReviewSystems))
                        historyCopy.push(res);
                        historyCopy.sort((a,b) => (a.section_id > b.section_id) ? 1 : -1)
                        return {p_ReviewSystems: historyCopy}
                    })
                })
            }

            // Get allergies info
            CallAPI({}, `patients/${this.state.patientId}/allergies`, 'GET', (res) => { 
                this.setState({
                    "p_Allergies": res
                });
            });

            // Get Medications info
            CallAPI({}, `patients/${this.state.patientId}/medications`, 'GET', (res) => { 
                this.setState({
                    "p_Meds": res
                });
            });

            // Get Surgeries info
            CallAPI({}, `patients/${this.state.patientId}/surgeries`, 'GET', (res) => { 
                this.setState({
                    "p_Surgeries": res
                });
            });

            // Get Dialysis Order
            CallAPI({}, `patients/${this.state.patientId}/dialysisOrder`, 'GET', (res) => { 
                this.setState({
                    "p_DOrder": res
                });
            });

            // Get the assessment and treatment plan information
            CallAPI({}, `patients/${this.state.patientId}/assessmentPlan`, 'GET', (res) => { 
                this.setState({
                    "p_Assessment": (res.Assessment ? PrepTextForDisplay(res.Assessment) : "NONE"),
                    "p_TreatmentPlan": (res.TreatmentPlan ? PrepTextForDisplay(res.TreatmentPlan) : "NONE")
                });
            });

            // Get upcoming schedule (for dialysis summary next appointment)
            CallAPI({}, `scheduling/patient/${this.state.patientId}`, 'GET', (res) => {
                if (res.success) {
                    this.setState({ "p_schedule": res.data });
                }
            });

            // Get dialysis summary
            CallAPI({}, `scheduling/dialysis-summary/${this.state.patientId}`, 'GET', (res) => {
                if (res.success) {
                    this.setState({
                        "p_totalDialysis": res.totalDialysis,
                        "p_lastDialysis": res.lastDialysisDate,
                        "p_nextAppointment": null // will be set from schedule data
                    });
                }
            });

        }, (message) => {
            this.setState({ "pFound": false });
        });
    }

    getAllergiesRows = () => {
        if (this.state.p_Allergies.length > 0) {
            return this.state.p_Allergies.map(function(row){
                return (
                    <li key={"allergies_" + row.id}><b>{row.name}</b>: {row.effect}</li>
                );
            });
        } else {
            return (<div>No records on file.</div>);
        }
    }

    getPastMedicalRows = () => {
        if (this.state.p_PastMedical.length > 0) {
            return this.state.p_PastMedical.map(function(row){
                if(row.value === true) {
                    return (
                        <li key={"pastMedical_" + row.id}>{row.title}</li>
                    )
                }
                else {
                    return (
                        <div key={"pastMedical_" + row.id}></div>
                    )
                }
            })
        }
        else {
            return (<div>No records on file.</div>);
        } 
    }

    getReviewSystemsRows = () => {
        if (this.state.p_ReviewSystems.length > 0) {
            // Deduplicate by section_id (API calls can push duplicates)
            const seen = new Set();
            const dedupedSections = this.state.p_ReviewSystems.filter(section => {
                if (seen.has(section.section_id)) return false;
                seen.add(section.section_id);
                return true;
            });

            // Filter to only sections that have at least one checked item
            const activeSections = dedupedSections.filter((section) =>
                section.items.some(item => item.value === true)
            );

            if (activeSections.length === 0) {
                return <div>No records on file.</div>;
            }

            return activeSections.map((section) => {
                const checkedItems = section.items.filter(item => item.value === true);
                return (
                    <div key={"ros_" + section.section_id} style={{ marginBottom: '12px' }}>
                        <b>{section.section_title}</b>
                        <ul className="profile-list" style={{ marginTop: '4px' }}>
                            {checkedItems.map(item => (
                                <li key={"ros_item_" + item.id}>{item.title}</li>
                            ))}
                        </ul>
                    </div>
                );
            });
        } else {
            return <div>No records on file.</div>;
        }
    }

    getMedicationsRows = () => {
        if (this.state.p_Meds.length > 0) {
            return this.state.p_Meds.map(function(row){
                return (
                    <li key={"medication_" + row.id}><b>{row.name}</b>, {row.dose}, {row.interval}</li>
                );
            });
        } else {
            return (<div>No records on file.</div>);
        }
    }

    getSurgeriesRows = () => {
        if (this.state.p_Surgeries.length > 0) {
            return this.state.p_Surgeries.map(function(row){
                return (
                    <li key={"surgery_" + row.id}><b>{row.info}</b>, Year performed: {row.year}</li>
                );
            });
        } else {
            return (<div>No records on file.</div>);
        }
    }

    getEditIcon = (destUrl, destTitle) => {
        if (this.state.userType === "doctor" || this.state.userType === "nurse") {
            return (
                <div className="patient-toolbar editLinkBottomRight">
                    <Button variant="outline-secondary"><a href={destUrl}><img src={EditIcon}
                                                                               alt={destTitle}/></a></Button>
                </div>
            );
        } else {
            return (<></>);
        }
    }

    render = () => {
        if (!this.state.pFound) {
            return (
                <div className="profile-page">
                    <div className="profile-not-found">
                        Patient not found.
                        <button className="logSubmit" style={{marginTop: '16px', width: 'auto'}} onClick={() => this.props.router.navigate(-1)}>Go Back</button>
                    </div>
                </div>
            );
        }

        const pid = this.state.patientId;
        const tz  = GetCookieFunction("User").tz;
        const canEdit = this.state.userType === "doctor" || this.state.userType === "nurse" || this.state.userType === "centeradmin" || this.state.userType === "executive";
        const isClinical = this.state.userType === "doctor" || this.state.userType === "nurse";

        return (
            <div>
                <PatientNav patientId={pid} />

                <div className="profile-page">
                    {/* ── Patient header ── */}
                    <div className="profile-header">
                        <div className="profile-header-info">
                            <h2>{this.state.pFName} {this.state.pLName} <span title={this.state.p_active ? "Active" : "Inactive"} style={{fontSize:'0.6em', verticalAlign:'middle'}}>{this.state.p_Active ? "🟢" : "🔴"}</span></h2>
                            {this.state.patientCode && <p style={{fontSize:'13px', color:'var(--text-muted)', marginTop:'2px'}}>ID: {this.state.patientCode}</p>}
                            <p><b>{this.state.gender} &nbsp;·&nbsp; Age: {BirthdayToAge(this.state.bDay, "—")}</b></p>
                        </div>
                    </div>

                    {/* ── Two-column grid on laptop, single on mobile ── */}
                    <div className="profile-grid">

                        {/* Personal Profile */}
                        <div className="profile-card">
                            <div className="profile-card-header">
                                <span>Personal Profile</span>
                                {canEdit && <div style={{display:'flex', gap:'6px'}}>
                                    <a href={`/patients/${pid}/editProfile`} className="profile-edit-btn" data-tooltip="Edit"><img src={EditIcon} alt="Edit" /></a>
                                    <a href={`/patients/${pid}/editProfile?funnel=1`} className="profile-edit-btn" data-tooltip="Edit all sections">
                                        <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" style={{opacity: 0.5}}>
                                            <path d="M22 3 L14 3 L12 7 L10 3 L2 3 L10 13 L10 21 L14 21 L14 13 Z"/>
                                        </svg>
                                    </a>
                                </div>}
                            </div>
                            <dl className="profile-dl">
                                <dt>Current Center</dt><dd>{this.state.p_CenterName || "—"}</dd>
                                <dt>Address</dt><dd>{this.state.address || "—"}{(this.state.p_City || this.state.p_District) && <br />}{this.state.p_City}{this.state.p_District ? `, ${this.state.p_District}` : ""}</dd>
                                <dt>Phone</dt><dd>{this.state.phone || "—"}</dd>
                                <dt>Email</dt><dd>{this.state.p_Email || "—"}</dd>
                            </dl>
                        </div>

                        {/* Patient Information */}
                        <div className="profile-card">
                            <div className="profile-card-header">
                                <span>Patient Information</span>
                                {canEdit && <a href={`/patients/${pid}/patientInfo`} className="profile-edit-btn" data-tooltip="Edit"><img src={EditIcon} alt="Edit" /></a>}
                            </div>
                            <dl className="profile-dl">
                                <dt>Risk Bond Signed</dt><dd>{this.state.p_RiskBondSigned || "—"}</dd>
                                <dt>Referring Doctor</dt><dd>{this.state.p_RefDocName}, {this.state.p_RefDocPhone}</dd>
                                <dt>Blood Group</dt><dd>{this.state.p_BloodGroup}</dd>
                                <dt>Transplant Year</dt><dd>{this.state.p_Transplant}</dd>
                                <dt>Hepatitis</dt><dd>{this.state.p_Hepatitis}</dd>
                                <dt>Registered</dt><dd>{this.state.p_RegDate ? GetTzAwareTime(this.state.p_RegDate, tz) : "—"}</dd>
                                <dt>Monthly Income</dt><dd>{this.state.p_Income || "—"}</dd>
                                <dt>Employed</dt><dd>{this.state.p_Employed}</dd>
                                <dt>Zakah Eligible</dt><dd>{this.state.p_Zakah}</dd>
                                <dt>Next of Kin</dt><dd>{this.state.nextKinName}, {this.state.nextKinNum}</dd>
                            </dl>
                            {this.state.p_CurIllnessHist && this.state.p_CurIllnessHist !== "NONE" && (
                                <div className="profile-text-block">
                                    <div className="profile-text-label">History of Present Illness</div>
                                    <div dangerouslySetInnerHTML={{__html: this.state.p_CurIllnessHist}} />
                                </div>
                            )}
                        </div>

                        {/* Dialysis Summary */}
                        <div className="profile-card">
                            <div className="profile-card-header">
                                <span>Dialysis Summary</span>
                                <div style={{display:'flex', gap:'6px'}}>
                                    <a href={`/patients/${pid}/schedule`} className="profile-edit-btn" data-tooltip="Schedule">
                                        <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" style={{opacity: 0.8}}>
                                            <rect x="3" y="4" width="18" height="18" rx="2" ry="2"/><line x1="16" y1="2" x2="16" y2="6"/><line x1="8" y1="2" x2="8" y2="6"/><line x1="3" y1="10" x2="21" y2="10"/>
                                        </svg>
                                    </a>
                                    <a href={`/patients/${pid}/visit-history`} className="profile-edit-btn" data-tooltip="Visit History">
                                        <img src={HistoryIcon} alt="Visit History" />
                                    </a>
                                </div>
                            </div>
                            <dl className="profile-dl">
                                <dt>Total Sessions</dt><dd>{this.state.p_totalDialysis ?? "—"}</dd>
                                <dt>Last Dialysis</dt><dd>{this.state.p_lastDialysis ? GetTzAwareTime(this.state.p_lastDialysis, tz) : "—"}</dd>
                                <dt>Next Appointment</dt><dd>{this.state.p_schedule && this.state.p_schedule.length > 0
                                    ? (() => {
                                        const s = this.state.p_schedule[0];
                                        const parts = s.scheduleDate.substring(0, 10).split('-');
                                        const d = new Date(parts[0], parts[1]-1, parts[2]);
                                        const dateStr = d.toLocaleDateString(undefined, { weekday: 'short', month: 'short', day: 'numeric' });
                                        const [h] = s.startTime.split(':');
                                        const hr = parseInt(h)%12||12;
                                        const ampm = parseInt(h)>=12 ? 'PM' : 'AM';
                                        return `${dateStr} at ${hr}:${s.startTime.split(':')[1]} ${ampm}`;
                                    })()
                                    : "—"}</dd>
                            </dl>
                        </div>

                        {/* Allergies */}
                        <div className="profile-card">
                            <div className="profile-card-header">
                                <span>Allergies</span>
                                {isClinical && <a href={`/patients/${pid}/allergies`} className="profile-edit-btn" data-tooltip="Edit"><img src={EditIcon} alt="Edit" /></a>}
                            </div>
                            <ul className="profile-list">{this.getAllergiesRows()}</ul>
                        </div>

                        {/* Medications */}
                        <div className="profile-card">
                            <div className="profile-card-header">
                                <span>Current Medications</span>
                                {isClinical && <a href={`/patients/${pid}/medications`} className="profile-edit-btn" data-tooltip="Edit"><img src={EditIcon} alt="Edit" /></a>}
                            </div>
                            <ul className="profile-list">{this.getMedicationsRows()}</ul>
                        </div>

                        {/* Past Medical History */}
                        <div className="profile-card">
                            <div className="profile-card-header">
                                <span>Past Medical History</span>
                                {isClinical && <a href={`/patients/${pid}/pastMedicalHistory`} className="profile-edit-btn" data-tooltip="Edit"><img src={EditIcon} alt="Edit" /></a>}
                            </div>
                            <ul className="profile-list">{this.getPastMedicalRows()}</ul>
                        </div>

                        {/* Surgery History */}
                        <div className="profile-card">
                            <div className="profile-card-header">
                                <span>Surgery History</span>
                                {isClinical && <a href={`/patients/${pid}/surgeries`} className="profile-edit-btn" data-tooltip="Edit"><img src={EditIcon} alt="Edit" /></a>}
                            </div>
                            <ul className="profile-list">{this.getSurgeriesRows()}</ul>
                        </div>

                        {/* Family & Social History */}
                        <div className="profile-card profile-card-wide">
                            <div className="profile-card-header">
                                <span>Family &amp; Social History</span>
                                {isClinical && <a href={`/patients/${pid}/familySocialHistory`} className="profile-edit-btn" data-tooltip="Edit"><img src={EditIcon} alt="Edit" /></a>}
                            </div>
                            <div className="profile-text-block">
                                <div className="profile-text-label">Social History</div>
                                <div dangerouslySetInnerHTML={{__html: this.state.p_SocialHist || "NONE"}} />
                            </div>
                            <div className="profile-text-block">
                                <div className="profile-text-label">Family History</div>
                                <div dangerouslySetInnerHTML={{__html: this.state.p_FamilyHist || "NONE"}} />
                            </div>
                        </div>

                        {/* Review of Systems */}
                        <div className="profile-card profile-card-wide">
                            <div className="profile-card-header">
                                <span>Review of Systems</span>
                                {isClinical && <a href={`/patients/${pid}/reviewSystems`} className="profile-edit-btn" data-tooltip="Edit"><img src={EditIcon} alt="Edit" /></a>}
                            </div>
                            <div className="normalText">{this.getReviewSystemsRows()}</div>
                        </div>

                        {/* Assessment & Treatment Plan */}
                        <div className="profile-card profile-card-wide">
                            <div className="profile-card-header">
                                <span>Assessment &amp; Treatment Plan</span>
                                {isClinical && <a href={`/patients/${pid}/assessmentPlan`} className="profile-edit-btn" data-tooltip="Edit"><img src={EditIcon} alt="Edit" /></a>}
                            </div>
                            <div className="profile-text-block">
                                <div className="profile-text-label">Assessment</div>
                                <div dangerouslySetInnerHTML={{__html: this.state.p_Assessment || "NONE"}} />
                            </div>
                            <div className="profile-text-block">
                                <div className="profile-text-label">Treatment Plan</div>
                                <div dangerouslySetInnerHTML={{__html: this.state.p_TreatmentPlan || "NONE"}} />
                            </div>
                        </div>

                        {/* Dialysis Order */}
                        <div className="profile-card profile-card-wide">
                            <div className="profile-card-header">
                                <span>Dialysis Order</span>
                                {GetCookieFunction("User").type === "doctor" && (
                                    <a href={`/patients/${pid}/dialysisorder`} className="profile-edit-btn" data-tooltip="Edit"><img src={EditIcon} alt="Edit" /></a>
                                )}
                            </div>
                            {this.state.p_DOrder?.Doctor_Fname ? (
                                <>
                                    <p className="profile-text-meta">Last updated by <b>Dr. {this.state.p_DOrder.Doctor_Fname} {this.state.p_DOrder.Doctor_Lname}</b> on {GetTzAwareTime(this.state.p_DOrder.Last_Edited_On, tz)}</p>
                                    <div className="profile-dorder-grid">
                                        <div className="profile-dorder-item"><span>Frequency</span><b>{this.state.p_DOrder.Frequency}x / week</b></div>
                                        <div className="profile-dorder-item"><span>Duration</span><b>{this.state.p_DOrder.Duration} min</b></div>
                                        <div className="profile-dorder-item"><span>Blood Flow</span><b>{this.state.p_DOrder.Blood_Flow} mL/min</b></div>
                                        <div className="profile-dorder-item"><span>Dry Weight</span><b>{this.state.p_DOrder.Dry_Weight} kg</b></div>
                                        <div className="profile-dorder-item"><span>Dialysate Flow</span><b>{this.state.p_DOrder.Dialysate_Flow} mL/min</b></div>
                                        <div className="profile-dorder-item"><span>Sodium</span><b>{this.state.p_DOrder.Sodium} mEq/L</b></div>
                                        <div className="profile-dorder-item"><span>Potassium</span><b>{this.state.p_DOrder.Potassium} mEq/L</b></div>
                                        <div className="profile-dorder-item"><span>Calcium</span><b>{this.state.p_DOrder.Calcium} mEq/L</b></div>
                                        <div className="profile-dorder-item"><span>Bicarbonate</span><b>{this.state.p_DOrder.Bicarbonate} mEq/L</b></div>
                                        <div className="profile-dorder-item"><span>Dialyzer Type</span><b>{this.state.p_DOrder.Dialyzer_Type}</b></div>
                                    </div>
                                    {this.state.p_DOrder.Comments && (
                                        <div className="profile-text-block">
                                            <div className="profile-text-label">Comments</div>
                                            <div dangerouslySetInnerHTML={{__html: this.state.p_DOrder.Comments}} />
                                        </div>
                                    )}
                                </>
                            ) : (
                                <p className="profile-text-meta">No dialysis order on file.</p>
                            )}
                        </div>

                    </div>
                </div>
            </div>
        );
    };
}

export default withRouter(PatientProfile)